import { computed } from 'vue';
import { useStore } from 'vuex';
import { settingsSections } from '../data/settingsConfig';
import { isDriversAdmin } from '@/utils/driversRoles';

/**
 * Permission filtering for Settings modal sections (Drivers bootstrap tabs).
 */
export function useSettingsPermissions() {
  const store = useStore();

  const allowedTabs = computed(() => store.state.app?.allowedTabs || []);
  const roles = computed(() => store.state.users?.user?.roles || []);

  const isSectionAllowed = (section) => {
    if (section.availableToAll) return true;
    if (section.adminOnly && !isDriversAdmin(roles.value)) return false;
    const tabKey = section.bootstrapTabKey;
    if (!tabKey) return false;
    const tabs = allowedTabs.value;
    if (!tabs.length) return true;
    return tabs.includes(tabKey);
  };

  const availableSections = computed(() =>
    settingsSections.filter(isSectionAllowed)
  );

  const deniedSections = computed(() =>
    settingsSections.filter((section) => !isSectionAllowed(section))
  );

  const hasAnySection = computed(() => availableSections.value.length > 0);

  const isSectionAvailable = (key) =>
    availableSections.value.some((section) => section.key === key);

  return {
    availableSections,
    deniedSections,
    hasAnySection,
    isSectionAvailable
  };
}
